export default class DownloadUtils {
    baixarBlob(data, nomeArquivo, tipoBlob){
        let blob = new Blob([data], {
            type: tipoBlob
        })
        const downloadLink = document.createElement('a')
        downloadLink.setAttribute('type', 'hidden')
        downloadLink.href = window.URL.createObjectURL(blob)
        downloadLink.download = nomeArquivo
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
    }

    gerarNomeArquivoComData(nomeArquivo){
        let dateTimeString = this.formatDateToFileName()
        return `${nomeArquivo}_${dateTimeString}.zip`
    }
    formatDateToFileName() {
        const date = new Date()
        const dateString = date.toISOString().split('T')[0]
        const timeString = date.toTimeString().split(' ')[0]
        return `${dateString}_${timeString}`
    }
}
